import clausionStateStore from "./store";
import { persist } from 'zustand/middleware';

// Define here the store that you want to persist
export const persistStore = persist(
    clausionStateStore,
    {
        name: 'clausion-dr',
        partialize: (state) => (
            {
                serviceUrl: state.serviceUrl,
                automaticCalculation: state.automaticCalculation,
                refreshMode: state.refreshMode,
                isRefreshInProgress: state.isRefreshInProgress,
                recentServiceUrls: state.recentServiceUrls,
                isLoggingEnabled: state.isLoggingEnabled,
                drErrorValue: state.drErrorValue,
                cacheTtl: state.cacheTtl,
                forceRefreshTimestamp: state.forceRefreshTimestamp,
                auth: state.auth,
            }
        )
    }
);
